import {useFormContext} from '@yandex-delivery/form'
import {useMemo} from 'react'

import type {DeliveryInterval} from 'src/shared/types'

import {mapDeliveryIntervals} from '../../DeliveryIntervalsNdd/utils'
import {toHoursAndMinutes, toLabel} from './utils'

export function useDeliveryIntervals(name: string) {
  const {watch} = useFormContext()

  const deliveryDate: string | undefined = watch(`${name}.deliveryDate`)
  const deliveryIntervals: DeliveryInterval[] | undefined = watch(`${name}.vertical.deliveryIntervals`)

  const deliveryIntervalsMap = useMemo(() => {
    if (deliveryIntervals === undefined) {
      return {}
    }

    return mapDeliveryIntervals(deliveryIntervals)
  }, [deliveryIntervals])

  const dateList = useMemo(() => {
    return Object.keys(deliveryIntervalsMap).map(date => ({
      label: toLabel(date),
      value: date,
    }))
  }, [deliveryIntervalsMap])

  const intervalList = useMemo(() => {
    if (deliveryDate === undefined) {
      return []
    }

    const intervals = deliveryIntervalsMap[deliveryDate]

    if (intervals === undefined) {
      return []
    }

    return intervals.map(interval => ({
      label: `${toHoursAndMinutes(interval.from)} - ${toHoursAndMinutes(interval.to)}`,
      value: interval,
    }))
  }, [deliveryDate, deliveryIntervalsMap])

  return {
    deliveryDate,
    dateList,
    intervalList,
  } as const
}
